import { store } from "../store/index";
import { logout, commonReset } from "../store/actions";

export function performLogout({ navigate, queryClient } = {}) {
  store.dispatch(logout());
  store.dispatch(commonReset());
  queryClient?.clear();

  if (typeof navigate === "function") {
    navigate("/login", { replace: true });
    return;
  }

  window.location.replace("/login");
}
